import { useContext, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { ROLE } from "../../../data/enums";
import { AuthenticationContext } from "../../../provider/AuthenticationProvider";
import { StyledButton, TitleText, TitleWrapper } from "../../../shared/styled/TitleBar";
import AddIcon from "../../../shared/svg/AddIcon";

const Title = () => {
    const navigate = useNavigate();
    const {
        user: { role },
    } = useContext(AuthenticationContext);
    const canCreate = role === ROLE.MANAGER;
    const activeTab: string = window.location.search;

    const kpiType = useMemo(() => {
        const match = activeTab.match(/tab=kpi-([^&]+)/);
        return match ? match[1] : null;
    }, [activeTab]);

    const onClickAddButton = () => {
        navigate("/kpis/create", {
            state: {
                type: kpiType === "category" ? "Category" : "Revenue",
            },
        });
    };

    return (
        <TitleWrapper>
            <TitleText>Quản lý chỉ tiêu</TitleText>
            {canCreate && (
                <StyledButton variant="contained" onClick={onClickAddButton}>
                    <AddIcon />
                    {kpiType === "category" ? "Tạo chỉ tiêu danh mục" : "Tạo chỉ tiêu doanh thu"}
                </StyledButton>
            )}
        </TitleWrapper>
    );
};

export default Title;
